"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const http_1 = require("@angular/common/http");
const core_1 = require("@angular/core");
const idm_application_properties_service_client_js_1 = require("@synisys/idm-application-properties-service-client-js");
const idm_common_util_frontend_1 = require("@synisys/idm-common-util-frontend");
const Observable_1 = require("rxjs/Observable");
const operators_1 = require("rxjs/operators");
const comment_model_1 = require("../model/comment.model");
let HttpCommentsService = class HttpCommentsService {
    constructor(http, applicationPropertiesService) {
        this.http = http;
        this.applicationPropertiesService = applicationPropertiesService;
        this.idmCmsServiceUrlKey = "comment-service-url";
        this.commentsPath = idm_common_util_frontend_1.StringTemplate.createTemplate `${"serviceUri"}/comment`;
        this.idmCommentServiceUrl$ = Observable_1.Observable.from(this.applicationPropertiesService.getProperty(this.idmCmsServiceUrlKey));
    }
    addComment(comment) {
        return this.idmCommentServiceUrl$
            .pipe(operators_1.switchMap((url) => {
            const urlOfRequest = this.commentsPath.replaceTemplate({
                serviceUri: url,
            });
            const headers = new http_1.HttpHeaders().set("Content-Type", "application/json");
            const options = { headers };
            return this.http.post(urlOfRequest, comment, options);
        }), operators_1.map((response) => {
            return new comment_model_1.CommentModel(response.parentId, response.id, response.messageText, response.createdBy, response.createdOn, response.updatedOn, response.resourceTypeId, response.resourceId, response.taggedUsers);
        }));
    }
    loadComments(resourceTypeId, resourceId) {
        return this.idmCommentServiceUrl$
            .pipe(operators_1.switchMap((url) => {
            const urlOfRequest = this.commentsPath.replaceTemplate({
                serviceUri: url,
            });
            const params = new http_1.HttpParams()
                .set("resourceTypeId", resourceTypeId.toString())
                .set("resourceId", resourceId);
            const headers = new http_1.HttpHeaders().set("Content-Type", "application/json");
            const options = { headers, params };
            return this.http.get(urlOfRequest, options);
        }), operators_1.map((response) => {
            return response.map((comment) => {
                return new comment_model_1.CommentModel(comment.parentId, comment.id, comment.messageText, comment.createdBy, comment.createdOn, comment.updatedOn, comment.resourceTypeId, comment.resourceId, comment.taggedUsers);
            });
        }));
    }
    editComment(comment) {
        return this.idmCommentServiceUrl$
            .pipe(operators_1.switchMap((url) => {
            const urlOfRequest = this.commentsPath.replaceTemplate({
                serviceUri: url,
            });
            const headers = new http_1.HttpHeaders().set("Content-Type", "application/json");
            const options = { headers };
            return this.http.put(urlOfRequest + "/" + comment.id, comment, options);
        }), operators_1.map((response) => {
            return new comment_model_1.CommentModel(response.parentId, response.id, response.messageText, response.createdBy, response.createdOn, response.updatedOn, response.resourceTypeId, response.resourceId, response.taggedUsers);
        }));
    }
    deleteComment(commentId) {
        return this.idmCommentServiceUrl$
            .pipe(operators_1.switchMap((url) => {
            const urlOfRequest = this.commentsPath.replaceTemplate({
                serviceUri: url,
            });
            return this.http.delete(urlOfRequest + "/" + commentId);
        }), operators_1.map((deletedComment) => deletedComment.id));
    }
};
HttpCommentsService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [http_1.HttpClient,
        idm_application_properties_service_client_js_1.ApplicationPropertiesService])
], HttpCommentsService);
exports.HttpCommentsService = HttpCommentsService;
//# sourceMappingURL=http-comments.service.js.map